import { FC } from "react";
import { LikesBoxContainer } from "./Styles";
import { Colors, FInter, FlexBox } from "@brg/ui";
import useIsDoubleGrid from "../../hooks/useIsDoubleGrid";
import styled, { useTheme } from "styled-components";
import { LayoutConst } from "core/modules/layout.module";
import LikesIcon24Fill from "shared/assets/24/LikesIcon24Fill";
import LikesIcon24Empty from "shared/assets/24/LikesIcon24Empty";
import { formatLikesCount } from "shared/helpers/formatLikesCount";

export enum LikesBoxSize {
  small = "small",
  medium = "medium",
  large = "large",
}

export interface LikesBoxProps {
  isInteractive?: boolean;
  isLiked?: boolean;
  likes: number;
  size?: LikesBoxSize;
  isBlackTheme?: boolean;
  onClick?: () => void;
  project?: any
}

const LikeIconWrapper = styled.div<{ isBlackTheme?: boolean; isLiked?: boolean }>`
  margin-right: 8px;
  svg {
    fill: ${({isLiked, theme, isBlackTheme}) => {
      if (isLiked) return Colors.geoWhite100;
      return Colors.geoWhite100;
    }} !important;
  }
  &:hover svg {
    fill: ${({isLiked}) => isLiked ? Colors.geoWhite100 : Colors.geoWhite100} !important;
  }
`

const LikesInnerWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 20px;
    width: 20px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      height: 16px;
      width: 16px;
    }
`

const LikesBoxCount = styled.div`
  color: ${Colors.geoWhite100};
  margin-bottom: -3px;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px; 

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 11px;
    line-height: 13px; 
  }
`

const CountNoGrid = styled(FInter.SmallTextDiv)`
  margin-bottom: -3px;
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }
`

/**
 * **LikesBox** - отображает сердце и цифру рядом. Руководит закрашиванием сердца и всеми его состояниями.
 * Конвертирует кол-во 1000 в 1к и тд. Имеет 3 размера: Small, Medium и Large.
 *
 * @param props
 */
export const LikesBox: FC<LikesBoxProps> = (props) => {
  const { isInteractive, isLiked, likes, onClick, isBlackTheme } = props;
  const isDoubleGrid = useIsDoubleGrid();
  const theme = useTheme();

  const onClickHandler = () => {
    if (isInteractive) {
      onClick?.()
    }
  };

  return (
    <LikesBoxContainer
      onClick={(e) => {
        e.preventDefault();
        onClickHandler();
      }}
      gx={6}
      isLiked={isLiked}
      isInteractive={isInteractive}
    >
      {!isDoubleGrid && (
        <FlexBox align="center" style={{gap: 4}}>
          <LikeIconWrapper isBlackTheme={isBlackTheme} isLiked={isLiked}>
            {isLiked ? (
                <LikesIcon24Fill fill={Colors.geoWhite100} />
              ) : (
                <LikesIcon24Empty fill={Colors.geoWhite100}/>
              )}

          </LikeIconWrapper>
          <CountNoGrid color={theme.app.text}>
            <div>{formatLikesCount(likes)}</div>
          </CountNoGrid>
        </FlexBox>
      )}
      {isDoubleGrid && (
        <>
          <LikesInnerWrapper>
            <LikeIconWrapper isBlackTheme={isBlackTheme} isLiked={isLiked}>
              {isLiked ? (
                  <LikesIcon24Fill fill={Colors.geoWhite100} />
                ) : (
                  <LikesIcon24Empty fill={Colors.geoWhite100} />
                )}
            </LikeIconWrapper>
          </LikesInnerWrapper>
          <LikesBoxCount>
            <div>{formatLikesCount(likes)}</div>
          </LikesBoxCount>
        </>
      )}
    </LikesBoxContainer>
  );
};
import { FC } from "react";
import { LikesBoxContainer } from "./Styles";
import { Colors, FInter, FlexBox } from "@brg/ui";
import useIsDoubleGrid from "../../hooks/useIsDoubleGrid";
import styled, { useTheme } from "styled-components";
import { LayoutConst } from "core/modules/layout.module";
import LikesIcon24Fill from "shared/assets/24/LikesIcon24Fill";
import LikesIcon24Empty from "shared/assets/24/LikesIcon24Empty";
import { formatLikesCount } from "shared/helpers/formatLikesCount";

export enum LikesBoxSize {
  small = "small",
  medium = "medium",
  large = "large",
}

export interface LikesBoxProps {
  isInteractive?: boolean;
  isLiked?: boolean;
  likes: number;
  size?: LikesBoxSize;
  isBlackTheme?: boolean;
  onClick?: () => void;
  project?: any
}

const LikeIconWrapper = styled.div<{ isBlackTheme?: boolean; isLiked?: boolean }>`
  margin-right: 8px;
  svg {
    fill: ${({isLiked, theme, isBlackTheme}) => {
      if (isLiked) return Colors.geoWhite100;
      return Colors.geoWhite100;
    }} !important;
  }
  &:hover svg {
    fill: ${({isLiked}) => isLiked ? Colors.geoWhite100 : Colors.geoWhite100} !important;
  }
`

const LikesInnerWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 20px;
    width: 20px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      height: 16px;
      width: 16px;
    }
`

const LikesBoxCount = styled.div`
  color: ${Colors.geoWhite100};
  margin-bottom: -3px;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px; 

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 11px;
    line-height: 13px; 
  }
`

const CountNoGrid = styled(FInter.SmallTextDiv)`
  margin-bottom: -3px;
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }
`

/**
 * **LikesBox** - отображает сердце и цифру рядом. Руководит закрашиванием сердца и всеми его состояниями.
 * Конвертирует кол-во 1000 в 1к и тд. Имеет 3 размера: Small, Medium и Large.
 *
 * @param props
 */
export const LikesBox: FC<LikesBoxProps> = (props) => {
  const { isInteractive, isLiked, likes, onClick, isBlackTheme } = props;
  const isDoubleGrid = useIsDoubleGrid();
  const theme = useTheme();

  const onClickHandler = () => {
    if (isInteractive) {
      onClick?.()
    }
  };

  return (
    <LikesBoxContainer
      onClick={(e) => {
        e.preventDefault();
        onClickHandler();
      }}
      gx={6}
      isLiked={isLiked}
      isInteractive={isInteractive}
    >
      {!isDoubleGrid && (
        <FlexBox align="center" style={{gap: 4}}>
          <LikeIconWrapper isBlackTheme={isBlackTheme} isLiked={isLiked}>
            {isLiked ? (
                <LikesIcon24Fill fill={Colors.geoWhite100} />
              ) : (
                <LikesIcon24Empty fill={Colors.geoWhite100}/>
              )}

          </LikeIconWrapper>
          <CountNoGrid color={theme.app.text}>
            <div>{formatLikesCount(likes)}</div>
          </CountNoGrid>
        </FlexBox>
      )}
      {isDoubleGrid && (
        <>
          <LikesInnerWrapper>
            <LikeIconWrapper isBlackTheme={isBlackTheme} isLiked={isLiked}>
              {isLiked ? (
                  <LikesIcon24Fill fill={Colors.geoWhite100} />
                ) : (
                  <LikesIcon24Empty fill={Colors.geoWhite100} />
                )}
            </LikeIconWrapper>
          </LikesInnerWrapper>
          <LikesBoxCount>
            <div>{formatLikesCount(likes)}</div>
          </LikesBoxCount>
        </>
      )}
    </LikesBoxContainer>
  );
};
